/**
 * 链接上传错误相关code
 * 主要针对youtube，google drive只有28
 * 2-下载失败;3-上传失败；4-下载速度过慢；5-下载执行异常；6-获取视频信息失败（获取信息的默认错误）; 21-私密视频；22-包含迪士尼公司内容；23-视频于该国家不可用；24-视频已删除；25-视频不可用；26-包含探索媒体公司内容；27-包含环球影业公司内容；28-不合法的链接；29-下载发生错误；210-无法下载；211-不完整的链接；212-无法下载（可重试）；213-超时；214-youtube处理中；215-不能下载直播视频
 */
export const UPLOAD_BY_LINK_DOWNLOAD_ERROR = 2;
export const UPLOAD_BY_LINK_UPLOAD_FAILED = 3;
export const UPLOAD_BY_LINK_DOWNLOAD_SPEED_SLOW = 4;
export const UPLOAD_BY_LINK_DOWNLOAD_EXCEPTION = 5;
export const UPLOAD_BY_LINK_FAILED_GET_INFORMATION = 6;
export const UPLOAD_BY_LINK_TOO_MUCH_REQUEST = 7;
export const UPLOAD_BY_LINK_PRIVATE_VIDEO = 21;
export const UPLOAD_BY_LINK_VIDEO_CONTAINS_DISNEY = 22;
export const UPLOAD_BY_LINK_COUNTRY_NOT_AVAILABLE = 23;
export const UPLOAD_BY_LINK_VIDEO_HAS_DELETED = 24;
export const UPLOAD_BY_LINK_VIDEO_NOT_AVAILABLE = 25;
export const UPLOAD_BY_LINK_VIDEO_CONTAINS_DISCOVERY = 26;
export const UPLOAD_BY_LINK_VIDEO_CONTAINS_UNIVERSAL = 27;
export const UPLOAD_BY_LINK_LINK_NOT_LEGITIMATE = 28;
export const UPLOAD_BY_LINK_DOWNLOAD_FAILED = 29;
export const UPLOAD_BY_LINK_UNABLE_DOWNLOAD_CANNOT_RETRIED = 210;
export const UPLOAD_BY_LINK_INCOMPLETE_LINKS = 211;
export const UPLOAD_BY_LINK_UNABLE_DOWNLOAD = 212;
export const UPLOAD_BY_LINK_UNABLE_DOWNLOAD_DATA = 213;
export const UPLOAD_BY_LINK_VIDEO_PROCESSING = 214;
export const UPLOAD_BY_LINK_CANNOT_DOWNLOAD_LIVE = 215;
export const UPLOAD_BY_LINK_CANNOT_LIVE_NO_START = 216; //直播未开始，不能下载
export const UPLOAD_BY_LINK_VIDEO_NOT_AVAILABLE_AND_NOT_DOWNLOAD = 217; //需要加入频道；不支持下载。
export const UPLOAD_BY_LINK_PREMIERES_NOT_START = 218; //首映未开始,不能下载
export const UPLOAD_BY_LINK_SHORT_CODE_ERROR = 219; //youtubeID 错误（例：short code错误）
export const UPLOAD_BY_LINK_IS_DRM_PROTECTED = 220; //视频收版权管理保护
